namespace $ {

	/** @deprecated */
	export class $shm_hitalama_map_transfer extends $mol_object {
		
		map(): $shm_hitalama_map {
			throw new Error("Not implemented")
		}

		@ $mol_action
		serialize_map() {
			const map = this.map()

			const table_nodes = new Set< $shm_hitalama_map_widget_entity_table >

			const widgets = map.Widgets_list()?.remote_list().map( ( b: $shm_hitalama_map_widget ) => {
				const table = b.Table()?.remote()
				if( table ) table_nodes.add( table )
				return $shm_hitalama_map_transfer_widget.serialize( b )
			} )
			const tables = [...table_nodes].map( t => $shm_hitalama_map_transfer_table.serialize( t ) )
			const files = map.Files()?.remote_list().flatMap( f => {
				try {
					return [ $shm_hitalama_map_transfer_file.serialize( f ) ]
				} catch (error) {
					if( !$mol_promise_like( error ) ) {
						console.error( error )
						return []
					}
					throw error
				}
			} )
			const search_statistics = map.Search_statistics()?.remote_list().map( f => f.serialize() )

			return {
				ref: map.link().toString(),

				title: map.title(),
				last_color: map.Last_color()?.val(),
				last_font_size: map.Last_font_size()?.val(),
				description: map.Description()?.val(),

				widgets,
				tables,
				files,
				search_statistics,

				// widgets_links: map.Widgets()?.remote_list().map( b => b.link().toString() ),
				// files_links: map.Files()?.remote_list().map( b => b.link().toString() ),
				// search_statistics_links: map.Search_statistics()?.remote_list().map( b => b.link().toString() ),
			}
		}

		@ $mol_action
		serialize_widgets( source: $shm_hitalama_map_widget[] ) {
			const table_nodes = new Set< $shm_hitalama_map_widget_entity_table >

			const widgets = source.map( b => {

				if( b.type() == 'table' ) {
					const table = b.Table()?.remote()
					if( table ) table_nodes.add( table )
				}

				return $shm_hitalama_map_transfer_widget.serialize( b )

			} )

			const tables = [...table_nodes].map( t => $shm_hitalama_map_transfer_table.serialize( t ) )

			return {
				widgets,
				tables,
			}
		}

		ref_remapping = new Map< string, string >
		ref_remap( ref: string ) {
			return this.ref_remapping.get( ref ) ?? ref
		}

		@ $mol_mem_key
		statistic_by_dto_link( dto_link: string ) {
			const item = this.map().Search_statistics(null)?.make( null )
			return item
		}

		@ $mol_mem_key
		widget_by_dto_link( dto_link: string ) {
			const widget = this.map().Widgets_list(null)?.make( null )
			return widget
		}

		@ $mol_mem_key
		file_by_dto_link( dto_link: string ) {
			const file = this.map().Files(null)?.make( null )
			return file
		}

		@ $mol_mem_key
		table_by_dto_link( dto_link: string ) {
			const table = this.map().Tables(null)?.make( null )
			return table
		}

		@ $mol_action
		deserialize_files( files: any[] | undefined ) {
			files?.forEach( dto => {
				const file = this.file_by_dto_link( dto.ref! )
				this.ref_remapping.set( dto.ref!, file?.link().toString()! )
				$shm_hitalama_map_transfer_file.deserialize( file!, dto )
			} )
		}

		@ $mol_action
		deserialize_tables( tables: any[] | undefined ) {
			tables?.forEach( dto => {
				const table = this.table_by_dto_link( dto.ref! )
				table?.Map(null)?.remote( this.map() )
				this.ref_remapping.set( dto.ref!, table?.link().toString()! )
				$shm_hitalama_map_transfer_table.deserialize( table!, dto )
			} )
		}

		@ $mol_action
		deserialize_statistics( statistics: any[] | undefined ) {
			statistics?.forEach( dto => {
				const item = this.statistic_by_dto_link( dto.ref! )
				this.ref_remapping.set( dto.ref!, item?.link().toString()! )
				item?.deserialize_data( dto )
				item?.deserialize_links( dto, this.ref_remapping )
			} )
		}

		@ $mol_action
		deserialize_widgets( widgets: any[] | undefined ) {
			const widget_and_dto = widgets?.map( dto => {
				const widget = this.widget_by_dto_link( dto.ref! )
				widget?.Map(null)?.remote( this.map() )
				this.map().Widget_by_name(null)?.key( dto.title!, 'auto' ).remote( widget )
				this.ref_remapping.set( dto.ref!, widget?.link().toString()! )
				return { widget, dto }
			} )
			
			widget_and_dto?.forEach( ({widget, dto})=> {
				$shm_hitalama_map_transfer_widget.deserialize_data( widget!, dto )
			} )

			widget_and_dto?.forEach( ({widget, dto})=> {
				$shm_hitalama_map_transfer_widget.deserialize_links( widget!, dto, this.ref_remap.bind(this) )
			} )
		}

		@ $mol_action
		deserialize( dto: ReturnType< $shm_hitalama_map['serialize'] > | any ) {
			this.map().title( dto.title )
			this.map().Last_color( dto.last_color )?.val( dto.last_color )
			this.map().Last_font_size( dto.last_font_size )?.val( dto.last_font_size )
			this.map().Description( dto.description )?.val( dto.description )

			this.deserialize_files( dto.files )
			this.deserialize_tables( dto.tables )
			this.deserialize_statistics( dto.search_statistics )
			this.deserialize_widgets( dto.widgets ?? (dto as any).blocks ) //todo old
		}
		
	}
	
}
